module.exports = __webpack_public_path__ + "img/map.6dbf2ef9.png";